var _circle, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZoom = function SvgZoom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 10,
    r: 7.5,
    stroke: "#2C2920"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2920",
    d: "m17.354 16.646 3 3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Zoom_svg__a)",
    stroke: "#292929"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10h7M11 6.5v7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Zoom_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(5 4)",
    d: "M0 0h12v12H0z"
  })))));
};
export default SvgZoom;